import React, { useEffect, useState } from 'react';
import axios from 'services/axios';
import Dropdown from 'components/atoms/Dropdown/index';
import walletIcon_active from '../../../../assets/svg/wallet-d-outline.svg';
import bankIcon_active from '../../../../assets/svg/bank.svg';
import walletIcon from '../../../../assets/svg/wallet-outline-grey.svg';
import bankIcon from '../../../../assets/svg/bank_grey.svg';
import arrow_left from '../../../../assets/svg/arrow-left.svg';
import arrow_right from '../../../../assets/svg/arrow-right.svg';

import accessBank from '../../../../assets/svg/banks/access.svg';
import firstBank from '../../../../assets/svg/banks/fbn.svg';
import gtBank from '../../../../assets/svg/banks/gtb.svg';
import zenithBank from '../../../../assets/svg/banks/zenith.svg';

import arrowUp from '../../../../assets/svg/arrow-up.svg';
import arrowDown from '../../../../assets/svg/arrow-down.svg';

import FormInput from 'components/atoms/FormInput';
import Button from 'components/atoms/Button';
import Alert from 'components/atoms/Alert';
import { BASE_URL, username } from 'services/http';
import { connect } from 'react-redux';
import { storeBanklist, toggleModal } from 'redux/app/app.action';
import SideComponent from '../SideComponent';
import Spinner from 'components/atoms/Spinner';
import ring_loader from '../../../../assets/gif/ring_loader_1.gif';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { getValues, setValues } from 'services/storage';

import { SelectPicker } from 'rsuite';
import countryList from '../../../../data/country_list.json';

import {
	generateRandomAlphanumeric,
	getBusinessInitials,
	getFileType,
	handleException,
} from 'utils';
import { truncate } from 'lodash';

const getCountry: any = (data: any) =>
	countryList.find((country) =>
		data.country
			? country.alpha2 === data.country
			: country.currency_code === data.currency
	);

const normalizeProviderKey = (value: string) =>
	(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

const getProviders = (networkData: any, selectedPocket: any) => {
	const country = getCountry(selectedPocket);
	const countryKey =
		normalizeProviderKey(country?.flag) || normalizeProviderKey(country?.name);
	const match = Object.keys(networkData || {}).find(
		(key) => normalizeProviderKey(key) === countryKey
	);
	return match ? networkData[match] : [];
};

const SingleTransfer = (props) => {
	const [loading, setLoading] = useState(false);
	const [bankLoading, setBankLoading] = useState(false);
	const [networkLoading, setNetworkLoading] = useState(false);
	const [dropdown, setDropdown] = useState(false);
	const [hoverStatus, setHoverStatus] = useState(false);
	const [selected, setSelected] = useState('sub_pocket_tf');
	const [selectBankName, setSelectBankName] = useState('');
	const [selectBank, setSelectBank] = useState<any>({});
	const [bankData, setBankData] = useState<any>([]);
	const [networkData, setNetworkData] = useState<any>([]);
	const [selectedBank, setSelectedBank] = useState<any>();
	const [pocketID, setPocketID] = useState('');

	const [storeBankCode, setStoreBankCode] = useState('');

	const [selectedPayoutAcct, setSelectedPayoutAcct] = useState('');
	const [transactionData, setTransactionData] = useState();

	const [accountNum, setAccountNum] = useState('');
	const [beneficiaryPocketID, setBeneficiaryPocketID] = useState('');
	const [narration, setNarration] = useState('');
	const [amount, setAmount] = useState('');
	const [bankName, setBankName] = useState('');
	const [inputBankName, setInputBankName] = useState('');

	const [beneficiaryErr, setBeneficiaryErr] = useState('');
	const [amountErr, setAmountErr] = useState('');
	const [bankNameErr, setBankNameErr] = useState('');
	const [accountName, setAccountName] = useState('');
	const [network, setNetwork] = useState<any>({});
	const [mobileNumber, setMobileNumber] = useState('');
	const [selectedPocket, setSelectedPocket] = useState<any>();

	const [narrationErr, setNarrationErr] = useState('');

	const NARRATION_REGEX = /^[a-zA-Z0-9\s]*$/;

	const handleNarration = (e) => {
		const value = e.target.value;

		if (NARRATION_REGEX.test(value)) {
			setNarration(value);
			setNarrationErr('');
		} else {
			const sanitized = value.replace(/[^a-zA-Z0-9\s]/g, '');
			setNarration(sanitized);
			setNarrationErr('Special characters are not allowed, only alphabets and numbers');
		}
	};


	const businessInitials =
		getBusinessInitials(props.pocketAccountInfo?.pocketOwner?.businessName) ||
		'SBT';

	const transactionRef = `${businessInitials}-S${Math.floor(
		Math.pow(12, 10 - 1) + Math.random() * 10 * Math.pow(12, 10 - 1)
	)}`;

	const navigate = useNavigate();

	const actionItemValue = 'APPROVE_DISBURSEMENT_BY_HEAD_CHURCH';

	const location: any = useLocation();

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!NARRATION_REGEX.test(narration)) {
			Alert('error', 'Narration contains unsupported special characters');
			return;
		}
		if (amount === '') {
			setAmountErr('Amount cannot be empty');
			return;
		} else {
			setAmountErr('');
		}

		const transactionData_ToPocket = {
			payoutAccount: pocketID,
			amount: amount,
			transactionPurpose: narration,
			transactionRef: transactionRef,
			destination: beneficiaryPocketID,
			currency: selectedPocket?.currency,
		};

		const transactionData_ToBank = {
			payoutAccount: pocketID,
			amount: amount,
			transactionPurpose: narration,
			transactionRef: transactionRef,
			destination: accountNum,
			bankcode: selectedBank?.bankCode,
			accountName: accountName,
			bankName: selectedBank?.bankName,
			currency: selectedPocket?.currency,
		};

		const mobile_money = {
			payoutAccount: pocketID,
			amount: amount,
			transactionPurpose: narration,
			transactionRef: transactionRef,
			network,
			mobileNumber,
			currency: selectedPocket?.currency,
			balance: selectedPocket?.pocketBalance,
			country: selectedPocket?.country,
		};

		if (amount === '') setAmountErr('Amount cannot be empty');

		if (selected === 'sub_pocket_tf') {
			if (beneficiaryPocketID.length < 10)
				setBeneficiaryErr('Beneficiary must contain 10 digits');
			if (beneficiaryPocketID === '') {
				Alert('error', 'Please, fill all fields');
			} else {
				navigate('/dashboard/disbursement/transaction_detail', {
					state: {
						fileData: transactionData_ToPocket,
						mode: selected,
						pocketID,
						balance: selectedPocket.pocketBalance,
					},
				});
			}
		} else if (selected === 'bank_tf') {
			if (bankName === '') setBankName('Please, enter Bank name');
			if (accountNum.length < 10)
				setBeneficiaryErr('Beneficiary must contain 10 digits');

			if (accountNum === '') {
				Alert('error', 'Please, fill all fields');
			} else {
				navigate('/dashboard/disbursement/transaction_detail', {
					state: {
						fileData: transactionData_ToBank,
						mode: selected,
						pocketID,
						balance: selectedPocket.pocketBalance,
					},
				});
			}
		} else {
			if (network === '') setBankName('Please, Select Mobile Network');
			// if (accountNum.length < 10)
			//   setBeneficiaryErr("Beneficiary must contain 10 digits");

			if (mobileNumber === '') {
				Alert('error', 'Please, fill all fields');
			} else {
				navigate('/dashboard/disbursement/transaction_detail', {
					state: {
						fileData: mobile_money,
						mode: selected,
						pocketID,
					},
				});
			}
		}
	};

	const handleAmount = (e) => {
		const regex = /^[0-9.\b]+$/;

		if (e.target.value === '' || regex.test(e.target.value)) {
			setAmount(e.target.value);
		}
	};

	const getNetwork = async () => {
		setNetworkLoading(true);
		try {
			const res = await axios.get(
				'https://pocket.seerbitapi.com/pocket/country/providers',
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${props.bearerToken}`,
						'Public-Key': `${props.public_key}`,
					},
				}
			);
			if (res.data) {
				setNetworkLoading(false);
				setNetworkData(res.data);
			}
		} catch (error) {
			setNetworkLoading(false);
			handleException(error);
		}
	};

	const getBanks = async () => {
		setBankLoading(true);
		try {
			const res = await axios.get(
				'https://pocket.seerbitapi.com/pocket/banks/category/NIP',
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${props.bearerToken}`,
						'Public-Key': `${props.public_key}`,
					},
				}
			);
			if (res?.data?.content?.length <= 0) {
				setBankLoading(false);
				Alert('error', res.data.message);
			} else {
				setBankLoading(false);
				setBankData(res.data.content);
				// storeBanklist(res.data.data)
				setDropdown(true);
				// handleDropdown()
			}
		} catch (error) {
			setBankLoading(false);
			handleException(error);
		}
	};

	const handleDropdown = () => {
		if (accountNum === '' || accountNum.length < 10) {
			Alert('error', 'Enter Account number first');
		}
	};

	const handleSelectBank = (data) => {
		setSelectBank(data.bankCode);
		setSelectBankName(data.bankname);
		setDropdown(false);
	};

	const fetchAccount = async () => {
		setLoading(true);
		try {
			const res = await axios.post(
				'https://pocket.seerbitapi.com/pocket/authenticate/name-enquiry', //"https://eoz4rjaukrwnecq.m.pipedream.net",
				{ bankcode: selectedBank.bankCode, accountnumber: accountNum },

				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${props.bearerToken}`,
						'Public-Key': `${props.public_key}`,
					},
				}
			);
			setLoading(false);
			if (res?.data?.data?.code === '00') {
				setAccountName(res.data.data.cutomername);
			} else {
				Alert('error', res.data.message);
				setAccountName('');
			}
		} catch (error: any) {
			setLoading(false);
			setAccountName('');
			handleException(error);
		}
	};

	const fetchDropDownData = (e) => {
		if (accountNum === '' || accountNum.length < 10) {
			Alert('error', 'Enter Account number first');
		} else {
			setInputBankName(e.target.value.toLowerCase());

			if (e.target.value.length >= 1) {
				setLoading(true);
				// if(dropdown){
				//     setLoading(false)
				//     setDropdown(false)
				// }else{
				if (bankData.length === 0) {
					//   getBanks();
				} else {
					setLoading(false);
					setDropdown(true);
				}
				// }
			}
		}
	};

	const handleHover = (data) => {
		setStoreBankCode(data.bankCode);
	};

	useEffect(() => {
		getBanks();
		getNetwork();
	}, []);

	useEffect(() => {
		if (selectedBank?.bankCode && accountNum.length === 10) {
			fetchAccount();
		}
	}, [selectedBank, accountNum]);

	const accountType = getValues('pocketType');

	const pockets = props.allPrimaryPockets.map((prim) => ({
		...prim,
		co: getCountry(prim)?.flag
			? getCountry(prim)?.flag.toLowerCase()
			: getCountry(prim)?.name.toLowerCase(),
		value: prim.pocketId,
		label: (
			<div className="flex items-center justify-between gap-4">
				<div className="flex gap-2 items-center w-4/12">
					<img
						src={`/flags/${getCountry(prim)?.flag
							? getCountry(prim)?.flag.toLowerCase()
							: getCountry(prim)?.name.toLowerCase()
							}.gif`}
						className="h-5 w-6"
					/>
					<span className="text-sm">
						({getCountry(prim)?.name?.split('_').join(' ') || "-"})
					</span>
				</div>
				<span className="font-semibold">{prim.pocketId}</span>
				<span className="font-normal no-wrap truncate">
					<small className="font-semibold text-[10px]">{`${prim.currency + ' '
						}`}</small>
					{Intl.NumberFormat().format(prim.pocketBalance)}
				</span>
			</div>
		),
	}));

	useEffect(() => {
		if (pockets?.length > 0) {
			setPocketID(pockets[0].value);
			setSelectedPocket(pockets[0]);
		}
	}, [pockets.length > 0]);

	// console.log(selectedPayoutAcct, 'selectedPayoutAcct');

	return (
		<div>
			<form
				className="py-3 mobile:p-0 mobile:rounded-[15px] max-h-[70vh] overflow-y-scroll custom_container mb-10"
				onSubmit={() => { }}
			>
				<div className="flex justify-center items-center">
					<div className="relative shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px] bg-white p-10 desktop:w-[43%] w-[80%] mobile:w-full rounded-[15px] flex flex-col gap-8">
						<div className="flex flex-col gap-2 w-full">
							<span className="font-semibold text-base leading-6 text-Black2 mx-2">
								Payout Account
							</span>
							{/* <div
                className="flex justify-between items-center gap-5 border rounded-md p-3 w-full cursor-pointer bg-Background3"
                onClick={() => {}}
              >
                <span className="text-Black2">{props.pocketId}</span>
              </div> */}

							<Select
								options={pockets.filter((e) => e.currency !== 'USD')}
								onChange={(o: any) => {
									setPocketID(o.value);
									setSelectedPocket(o);
								}}
								defaultValue={pockets[0]} // Automatically select the first item
							/>
						</div>
						<div className="flex flex-col gap-2 w-full">
							<span className="font-semibold text-base leading-6 text-Black2 mx-2">
								Select Transfer Type
							</span>
							<div className="bg-GrayCustom6 flex rounded-md overflow-hidden w-[100%] mobile:w-full">
								<span
									className={`${selected === 'sub_pocket_tf' && 'bg-white border'
										} flex justify-center items-center gap-3 p-3 w-full rounded-md text-base mobile:text-sm cursor-pointer`}
									onClick={() => setSelected('sub_pocket_tf')}
								>
									<img
										src={
											selected === 'sub_pocket_tf'
												? walletIcon_active
												: walletIcon
										}
										alt="walletIcon"
										className="w-4 h-4"
									/>
									<p
										className={`${selected === 'sub_pocket_tf'
											? 'text-Black4 font-semibold'
											: 'text-GrayCustom font-normal'
											} truncate`}
									>
										Sub Pocket
									</p>
								</span>
								{!selectedPocket || selectedPocket?.currency === 'NGN' ? (
									<span
										className={`${selected === 'bank_tf' && 'bg-white border'
											} flex justify-center items-center gap-3 p-3 w-full rounded-md text-base mobile:text-sm cursor-pointer`}
										onClick={() => setSelected('bank_tf')}
									>
										<img
											src={selected === 'bank_tf' ? bankIcon_active : bankIcon}
											alt="bankIcon"
											className="w-4 h-4"
										/>
										<p
											className={`${selected === 'bank_tf'
												? 'text-Black4 font-semibold'
												: 'text-GrayCustom font-normal'
												} truncate`}
										>
											Bank Transfer
										</p>
									</span>
								) : (
									<span
										className={`${selected === 'mobile_money' && 'bg-white border'
											} flex justify-center items-center gap-3 p-3 w-full rounded-md text-base mobile:text-sm cursor-pointer`}
										onClick={() => setSelected('mobile_money')}
									>
										<img
											src={
												selected === 'mobile_money' ? bankIcon_active : bankIcon
											}
											alt="bankIcon"
											className="w-4 h-4"
										/>
										<p
											className={`${selected === 'mobile_money'
												? 'text-Black4 font-semibold'
												: 'text-GrayCustom font-normal'
												} truncate`}
										>
											Mobile Money
										</p>
									</span>
								)}
							</div>
						</div>

						<div className="flex mobile:flex-col justify-between items-end gap-5">
							{selected === 'sub_pocket_tf' ? (
								<FormInput
									type="text"
									name="beneficiary_pocketId"
									placeholder="Pocket ID"
									style="w-full"
									inputStyle="border border-transparent text-Black2"
									label="Pocket ID"
									labelStyle="font-semibold text-base leading-6 text-Black2"
									value={beneficiaryPocketID}
									onChange={(e) => setBeneficiaryPocketID(e.target.value)}
									validationErr={beneficiaryErr}
								/>
							) : (
								selected === 'bank_tf' && (
									<>
										<FormInput
											type="text"
											name="beneficiary_sccount_number"
											placeholder="Account number"
											style="w-full w-full"
											inputStyle="border border-transparent text-Black2"
											label="Account Number"
											labelStyle="font-semibold text-base leading-6 text-Black2"
											value={accountNum}
											max={10}
											onChange={(e) => {
												const p = e.target.value;
												setAccountNum(p);
												if (p.length < 10) setAccountName('');
											}}
											validationErr={bankNameErr}
										/>
										{/* <span>{selectBank}</span> */}

										<div className="w-full relative">
											{/* <div
                      className={`flex flex-col items-center rounded-md overflow-hidden w-full bg-NoColor outline-none relative cursor-pointer`}
                      onClick={handleDropdown}
                    > */}
											<label
												className={`font-semibold text-base leading-6 text-Black2 m-2`}
											>
												Select Bank
											</label>
											<Select
												options={bankData.map((data: any) => ({
													...data,
													label: data.bankName,
													value: data.bankCode,
												}))}
												isLoading={bankLoading}
												name="bank_name"
												value={selectedBank}
												onChange={(e: any) => {
													setSelectedBank({
														...e,
														label: e.bankName,
														value: e.bankCode,
													});
												}}
												placeholder="Select Bank"
												styles={{
													control: (baseStyles) => ({
														...baseStyles,
														width: '100%',

														marginTop: '10px',
													}),
												}}
											/>
										</div>
									</>
								)
							)}

							{selected === 'mobile_money' && (
								<>
									<div className="w-full relative">
										<label
											className={`font-semibold text-base leading-6 text-Black2 m-2`}
										>
											Select Network
										</label>
										<Select
											options={
												selectedPocket
													? getProviders(networkData, selectedPocket).map(
														(value: string) => ({ label: value, value })
													)
													: []
											}
											isLoading={networkLoading}
											name="bank_name"
											value={network}
											onChange={(e: any) => {
												setNetwork({
													...e,
													label: e.label,
													value: e.value,
												});
											}}
											placeholder="Select Network"
											styles={{
												control: (baseStyles) => ({
													...baseStyles,
													width: '100%',

													marginTop: '10px',
												}),
											}}
										/>
									</div>
									<FormInput
										type="text"
										name="beneficiary_sccount_number"
										placeholder="Mobile Number"
										style="w-full w-full"
										inputStyle="border border-transparent text-Black2"
										label="Mobile Number"
										labelStyle="font-semibold text-base leading text-Black2"
										value={mobileNumber}
										max={14}
										onChange={(e) => {
											setMobileNumber(e.target.value);
										}}
										validationErr={''}
									/>
								</>
							)}
						</div>

						{selected === 'bank_tf' && (
							<div>
								<p className="m-2 text-base font-semibold text-Black2">
									Account name
								</p>
								<div
									className={`rounded-lg mb-0 px-4 py-3 text-sm bg-slate-100 text-gray-600`}
								>
									{loading ? (
										<div className="flex animate-pulse w-full gap-3">
											<div className={`rounded h-5 w-3/6 bg-gray-300`}></div>
											<div className={`rounded h-5 w-2/6 bg-gray-300`}></div>
										</div>
									) : (
										<span
											className={`${accountName === '' && 'text-gray-400'}`}
										>
											{accountName ? (
												<strong>{accountName}</strong>
											) : (
												'The account name is auto-generated'
											)}
										</span>
									)}
								</div>
							</div>
						)}

						{/* </div> */}

						<FormInput
							type="text"
							name="amount"
							placeholder="Enter amount"
							style="w-full"
							inputStyle="border border-transparent text-Black2"
							label="Amount"
							labelStyle="font-semibold text-base leading-6 text-Black2"
							value={amount}
							onChange={handleAmount}
							validationErr={amountErr}
						/>

						<FormInput
							type="text"
							name="narration"
							placeholder="Enter narration"
							style="w-full"
							inputStyle="border border-transparent text-Black2"
							label="Narration"
							labelStyle="font-semibold text-base leading-6 text-Black2"
							value={narration}
							onChange={handleNarration}
							validationErr={narrationErr}
						/>
					</div>
				</div>
			</form>
			{accountType !== 'PRIMARY_POCKETc' && (
				<div className="flex justify-between items-center absolute w-full bottom-0 left-0 py-8 px-16 mobile:py-4 mobile:px-10 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
					<Button
						btnType="button"
						btnText="Cancel"
						btnStyle="brounded-lg truncate flex gap-3 justify-center items-center w-[216px] mobile:w-fit mobile:px-8 px-3 py-2 font-semibold text-sm border border-gray-200 leading-7 flex-row-reverse rounded-lg truncate"
						disabled={false}
						disabledClass=""
						onClick={() => navigate('/dashboard/home')}
					/>
					<Button
						btnType="submit"
						btnText="Initiate Transfer"
						btnStyle="bg-DarkBg3 text-white rounded-lg truncate flex gap-3 justify-center items-center w-[216px] mobile:w-fit mobile:px-8 px-3 py-2 font-semibold flex-row-reverse rounded-lg truncate create-button"
						disabled={false}
						disabledClass=""
						onClick={(e) => handleSubmit(e)}
					/>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state: any) => ({
	bankList: state.app.bankList,
	fileData: state.app?.fileData,
	bearerToken: state.auth.token,
	public_key: state.auth.public_key,
	modalState: state.app.modalState,
	pocketId: state.auth.pocket_data?.pocketId,
	pocketAccountInfo: state.pocket.pocketAccountInfo,
	allPrimaryPockets: state.pocket.allPrimaryPockets,
});

const mapDispatchToProps = (dispatch: any) => ({
	toggleModal: () => dispatch(toggleModal()),
	storeBanklist: (data: any) => dispatch(storeBanklist(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleTransfer);
